import type { FC } from 'react';
import React, { useMemo } from 'react';

import { Box } from '@mui/material';

import {
  CheckInCircleGreenBigIcon,
  CurrentIndicatorIcon,
  EmptyIndicatorIcon,
} from '@setup/svg-icons/svg-icons';

import { StepperItem, StepperLine } from './Stepper.styled';

type Props = {
  count: number;
  selected: number;
};

export const Stepper: FC<Props> = ({ count, selected }) => {
  const array = useMemo(() => Array(count).fill(''), [count]);

  return (
    <Box display="flex" alignItems="center">
      {array.map((_, index) => (
        <React.Fragment key={index}>
          <StepperItem isActive={selected >= index + 1} isDone={selected > index + 1}>
            {selected === index + 1 ? (
              <CurrentIndicatorIcon />
            ) : selected > index + 1 ? (
              <CheckInCircleGreenBigIcon />
            ) : (
              <EmptyIndicatorIcon />
            )}
          </StepperItem>
          {array.length > index + 1 ? (
            <StepperLine isActive={selected > index + 1 || selected === array.length} />
          ) : null}
        </React.Fragment>
      ))}
    </Box>
  );
};
